var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBarcodeButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "barcode-icon",
    width: "100%",
    viewBox: "0 0 92 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Barcode Button") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-11.4%",
    y: "-30.0%",
    width: "122.8%",
    height: "160.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.666383605   0 0 0 0 0.666383605   0 0 0 0 0.666383605  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("polygon", {
    id: "path-2",
    points: "0 35 92 35 92 0 0 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3545447,2 C7.88793499,2 1,8.8303434 1,17.2257428 L1,18.7742572 C1,27.1696566 7.88793499,34 16.3545447,34 L75.6454553,34 C84.1118754,34 91,27.1696566 91,18.7742572 L91,17.2257428 C91,8.8303434 84.1118754,2 75.6454553,2 L16.3545447,2 Z",
    id: "Fill-1",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-4"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#52356E",
    mask: "url(#mask-3)",
    points: "36 30 38 30 38 5 36 5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#52356E",
    mask: "url(#mask-3)",
    points: "22 30 24 30 24 5 22 5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#52356E",
    mask: "url(#mask-3)",
    points: "41 30 43 30 43 5 41 5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    fill: "#52356E",
    mask: "url(#mask-3)",
    points: "54 30 56 30 56 5 54 5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    fill: "#52356E",
    mask: "url(#mask-3)",
    points: "68 30 70 30 70 5 68 5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    fill: "#52356E",
    mask: "url(#mask-3)",
    points: "28 30 34 30 34 5 28 5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-10",
    fill: "#52356E",
    mask: "url(#mask-3)",
    points: "13 30 19 30 19 5 13 5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-11",
    fill: "#52356E",
    mask: "url(#mask-3)",
    points: "73 30 79 30 79 5 73 5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-12",
    fill: "#52356E",
    mask: "url(#mask-3)",
    points: "46 30 52 30 52 5 46 5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-13",
    fill: "#52356E",
    mask: "url(#mask-3)",
    points: "58 30 64 30 64 5 58 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6837144,1.50345257 C8.31111419,1.50345257 1.49965972,8.33232208 1.49965972,16.7259099 L1.49965972,18.2740901 C1.49965972,26.6676779 8.31111419,33.4965474 16.6837144,33.4965474 L75.3162856,33.4965474 C83.6886984,33.4965474 90.5003403,26.6676779 90.5003403,18.2740901 L90.5003403,16.7259099 C90.5003403,8.33232208 83.6886984,1.50345257 75.3162856,1.50345257 L16.6837144,1.50345257 Z M75.3162856,35 L16.6837144,35 C7.48423931,35 0,27.496832 0,18.2740901 L0,16.7259099 C0,7.50316799 7.48423931,0 16.6837144,0 L75.3162856,0 C84.5159481,0 92,7.50316799 92,16.7259099 L92,18.2740901 C92,27.496832 84.5159481,35 75.3162856,35 L75.3162856,35 Z",
    id: "Fill-14",
    fill: "#52356E",
    mask: "url(#mask-3)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarcodeButton);
export default __webpack_public_path__ + "static/media/barcode-button.44ca881d.svg";
export { ForwardRef as ReactComponent };